import React from 'react';
import { format } from 'date-fns';

import './index.scss';

const EMPTY_DATE = '--/--/----';

const formatted = (date: Date | null | undefined) => (
  date ? format(date, 'dd/MM/yyyy') : EMPTY_DATE
);

// Deixa explicito que a selecao e de duas datas: o intervalo inteiro fica no
// mesmo azul, entao a cor sozinha nao diz quantos cliques faltam. Enquanto o
// fim nao foi travado com o segundo clique, ele aparece como --/--/----.
export default function RangeHint({
  startDate,
  endDate,
}: {
  startDate?: Date | null,
  endDate?: Date | null,
}) {
  return (
    <div className="ds-datepicker-range-hint">
      <span className="ds-datepicker-range-hint__field">
        <span className="ds-datepicker-range-hint__label">Início</span>
        <span className="ds-datepicker-range-hint__value">{formatted(startDate)}</span>
      </span>
      <span className="ds-datepicker-range-hint__field">
        <span className="ds-datepicker-range-hint__label">Fim</span>
        <span className="ds-datepicker-range-hint__value">{formatted(endDate)}</span>
      </span>
    </div>
  );
}
